import { buildWhatsAppLink } from './sendCheckQrWhatsApp';

export const sendCheckQrEmail = async ({ companyData, reservation, action, link }) => {
  if (!reservation?.clientPhone) {
    return { success: false, error: 'Cliente sem telefone cadastrado para WhatsApp' };
  }

  try {
    const message = [
      `Olá ${reservation.clientName || 'Cliente'}!`,
      `Seu QR para ${action === 'checkout' ? 'check-out' : 'check-in'} da reserva está pronto.`,
      `Serviço: ${reservation.serviceName || '-'}`,
      `Link de confirmação: ${link}`
    ].join(' ');

    const whatsappLink = buildWhatsAppLink({
      phone: reservation.clientPhone,
      message
    });

    if (!whatsappLink) {
      return { success: false, error: 'Não foi possível montar o link do WhatsApp.' };
    }

    window.open(whatsappLink, '_blank', 'noopener,noreferrer');
    return { success: true, link: whatsappLink };
  } catch (error) {
    console.error('Erro ao abrir WhatsApp:', error);
    return { success: false, error: error.message };
  }
};
